(() => {
  if (window.ialProductGalleryQaLoaded) return;
  window.ialProductGalleryQaLoaded = true;

  const MAIN_SELECTOR = ':scope > slider-component:not(.thumbnail-slider)';

  function getGalleryParts(gallery) {
    const main = gallery.querySelector(MAIN_SELECTOR) || gallery.querySelector('slider-component');
    const list = main ? main.querySelector('.product__media-list') : null;
    const slides = list ? Array.from(list.querySelectorAll('.product__media-item')) : [];
    const buttons = main ? Array.from(main.querySelectorAll(':scope > .slider-buttons .slider-button')) : [];
    const thumbs = Array.from(gallery.querySelectorAll('.thumbnail-slider .thumbnail, .thumbnail-list__item button'));
    return { main, list, slides, buttons, thumbs };
  }

  function slideWidth(list) {
    return list ? Math.max(1, Math.round(list.clientWidth || list.getBoundingClientRect().width || 1)) : 1;
  }

  function currentIndex(list, slides) {
    if (!list || !slides.length) return 0;
    const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const scrollIndex = Math.round(list.scrollLeft / slideWidth(list));
    return Math.min(Math.max(activeIndex >= 0 ? activeIndex : scrollIndex, 0), slides.length - 1);
  }

  function setActive(gallery, index) {
    const { list, slides, thumbs } = getGalleryParts(gallery);
    if (!list || slides.length <= 1) return;
    const safeIndex = Math.min(Math.max(index, 0), slides.length - 1);
    const target = slides[safeIndex];
    list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === safeIndex));
    const mediaId = target.getAttribute('data-media-id');
    thumbs.forEach((thumb) => {
      const thumbItem = thumb.closest('[data-target]');
      const isCurrent = thumbItem && mediaId && thumbItem.getAttribute('data-target') === mediaId;
      if (isCurrent) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    updateCounter(gallery, safeIndex);
  }

  function updateCounter(gallery, indexOverride) {
    const { list, slides } = getGalleryParts(gallery);
    const counter = gallery.querySelector('.ial-product-gallery-counter');
    if (!counter || !list || slides.length <= 1) return;
    const index = typeof indexOverride === 'number' ? indexOverride : Math.round(list.scrollLeft / slideWidth(list));
    counter.textContent = `${Math.min(Math.max(index, 0), slides.length - 1) + 1}/${slides.length}`;
  }

  function ensureCounter(gallery) {
    const { slides } = getGalleryParts(gallery);
    if (slides.length <= 1) {
      gallery.classList.add('ial-product-gallery--single');
      gallery.querySelectorAll('.ial-product-gallery-counter').forEach((node) => node.remove());
      return;
    }
    gallery.classList.remove('ial-product-gallery--single');
    if (!gallery.querySelector('.ial-product-gallery-counter')) {
      const counter = document.createElement('div');
      counter.className = 'ial-product-gallery-counter';
      gallery.appendChild(counter);
    }
    updateCounter(gallery);
  }

  function initGallery(gallery) {
    if (gallery.dataset.ialProductGalleryQaBound === 'true') return;
    gallery.dataset.ialProductGalleryQaBound = 'true';
    ensureCounter(gallery);
    const { list, slides, buttons, thumbs } = getGalleryParts(gallery);
    if (!list || slides.length <= 1) return;

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const direction = button.classList.contains('slider-button--prev') ? -1 : 1;
        setActive(gallery, currentIndex(list, slides) + direction);
      }, true);
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = thumb.closest('[data-target]')?.getAttribute('data-target');
        const index = slides.findIndex((slide) => slide.getAttribute('data-media-id') === target);
        if (index >= 0) window.setTimeout(() => setActive(gallery, index), 0);
      }, true);
    });

    let startX = 0;
    let startY = 0;
    list.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
    }, { passive: true });

    list.addEventListener('pointerup', (event) => {
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      startX = 0;
      startY = 0;
      if (Math.abs(deltaX) < 35 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      setActive(gallery, currentIndex(list, slides) + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    list.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => updateCounter(gallery));
    }, { passive: true });
  }

  function initAll(root = document) {
    root.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
